// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"SectionContainer_sectionContainer__16Rcg","sectionWrapper":"SectionContainer_sectionWrapper__cU-uD"};